module.exports = __webpack_public_path__ + "static/media/lowerRisk.994eeafb.mp3";